import { render, staticRenderFns } from "./DOILink.vue?vue&type=template&id=33373c55&scoped=true"
import script from "./DOILink.vue?vue&type=script&setup=true&lang=ts"
export * from "./DOILink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DOILink.vue?vue&type=style&index=0&id=33373c55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33373c55",
  null
  
)

export default component.exports